import "./styles.css";
import { useEffect, useState } from "react";

import { Sidebar } from "./components/Sidebar";
import { ERPHero } from "./components/erp/ERPHero";
import { ERPAbout } from "./components/erp/ERPAbout";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

// import { Hero } from './components/Hero';
import { Navbar } from "./components/Navbar";
import { ERPFeatures } from "./components/erp/ERPFeatures";
import { ERPModules } from "./components/erp/ERPModules";

export default function DukareeApp() {
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    document.title = "Ethos Tech Hub Limited";
  }, []);

  return (
    <div className={`bg-gray-100 min-h-screen ${darkMode ? "dark" : ""}`}>
      <Navbar />
      <ERPHero />
      <ERPAbout />

      <div className="relative w-full max-w-4xl mx-auto my-12 py-12">
        <div className="lg:col-span-1">
          <ERPModules />
        </div>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-1 gap-6 px-6 mt-12">
        <div className="lg:col-span-1">
          <ERPFeatures />
        </div>
      </div>

      <Contact />
      <Footer />
      {/* <WhatsAppButton /> */}
    </div>
  );
}
